import propTypes from 'prop-types';

const greetings = (time) => (time.getHours() >= 12 ? 'GoodEvening' : 'GoodMorning');

greetings.propTypes = {
    time: propTypes.time
};

export default greetings;
